export default __webpack_public_path__ + "static/media/trash-icon-white.080698a0.svg";